/* global __APP_VERSION__ */
// Value comes from manifest.xml's <Version>, injected by webpack.DefinePlugin.
export const APP_VERSION = __APP_VERSION__;
